import api from './api';

class LeaveTypeService {
  /**
   * Create leave type
   * @param {Object} leaveTypeData - Leave type data
   * @returns {Promise<Object>} API response
   */
  static async createLeaveType(leaveTypeData) {
    try {
      const response = await api.post('/leave-type/create', leaveTypeData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get all leave types
   * @returns {Promise<Object>} API response
   */
  static async getAllLeaveTypes() {
    try {
      const response = await api.get('/leave-type/all');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get leave type by ID
   * @param {string} leaveTypeId - Leave type ID
   * @returns {Promise<Object>} API response
   */
  static async getLeaveTypeById(leaveTypeId) {
    try {
      const response = await api.get(`/leave-type/${leaveTypeId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Update leave type
   * @param {string} leaveTypeId - Leave type ID
   * @param {Object} updateData - Update data
   * @returns {Promise<Object>} API response
   */
  static async updateLeaveType(leaveTypeId, updateData) {
    try {
      const response = await api.patch(`/leave-type/update/${leaveTypeId}`, updateData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Delete leave type
   * @param {string} leaveTypeId - Leave type ID
   * @returns {Promise<Object>} API response
   */
  static async deleteLeaveType(leaveTypeId) {
    try {
      const response = await api.delete(`/leave-type/delete/${leaveTypeId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Get leave type statistics
   * @param {string} leaveTypeId - Leave type ID
   * @returns {Promise<Object>} API response
   */
  static async getLeaveTypeStats(leaveTypeId) {
    try {
      const response = await api.get(`/leave-type/stats/${leaveTypeId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  /**
   * Seed default leave types
   * @returns {Promise<Object>} API response
   */
  static async seedDefaultLeaveTypes() {
    try {
      const response = await api.post('/leave-type/seed-defaults');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
}

export default LeaveTypeService;